import { startCase } from "lodash";

export const mapEnumToSelect = (val: { [value: string]: string }) =>
  Object.entries(val).map(([label, value]) => ({
    value,
    label: startCase(label),
  }));
